import { BellAlertIcon, Squares2X2Icon, UsersIcon, BuildingStorefrontIcon, BuildingOfficeIcon, CreditCardIcon, LinkIcon, FolderIcon, MapPinIcon, DocumentTextIcon, QuestionMarkCircleIcon } from '@heroicons/react/24/outline';

export const navTree = [
  {
    type: 'group',
    name: 'Cadastros',
    icon: FolderIcon,
    children: [
      {
        name: 'Áreas',
        to: '/app/areas',
        roles: ['Manager', 'Admin', 'AdminMaster'],
        icon: MapPinIcon
      },
      {
        name: 'Empresas',
        to: '/app/companies',
        roles: ['AdminMaster'],
        icon: BuildingOfficeIcon
      },
      {
        name: 'Equipe',
        to: '/app/staff',
        roles: ['Manager', 'Admin', 'AdminMaster'],
        icon: UsersIcon
      },
      {
        name: 'Mesas',
        to: '/app/tables',
        roles: ['Manager', 'Admin', 'AdminMaster'],
        icon: Squares2X2Icon
      },
      {
        name: 'Restaurantes',
        to: '/app/restaurants',
        roles: ['Admin', 'AdminMaster'],
        icon: BuildingStorefrontIcon
      }
    ]
  },
  {
    type: 'item',
    name: 'Chamadas',
    to: '/app/calls',
    roles: ['Waiter', 'Manager', 'Admin', 'AdminMaster'],
    icon: BellAlertIcon
  },
  {
    type: 'item',
    name: 'Integrações',
    to: '/app/integrations',
    roles: ['AdminMaster'],
    icon: LinkIcon
  },
  {
    type: 'item',
    name: 'Assinaturas',
    to: '/app/subscriptions',
    roles: ['AdminMaster'],
    icon: CreditCardIcon
  },
  {
    type: 'item',
    name: 'Minha Assinatura',
    to: '/app/my-subscription',
    roles: ['Admin'],
    icon: DocumentTextIcon,
    requiresSubscription: true
  },
  {
    type: 'item',
    name: 'Ajuda & Suporte',
    to: '/app/help',
    roles: ['Waiter', 'Manager', 'Admin', 'AdminMaster'],
    icon: QuestionMarkCircleIcon
  }
];

export const navItems = navTree.flatMap((entry) => (entry.children ? entry.children : [entry])).filter((entry) => Boolean(entry.to));
